module.exports = __webpack_public_path__ + "static/media/D-edit-white.c7c4386f.svg";